import identity from "lodash/fp/identity";

import { Group } from "@mapmycustomers/shared/types/entity";
import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import { DisplayType } from "@app/scene/home/enum/DisplayType";
import { RecordsStats } from "@app/scene/home/types/RecordsStats";
import { userDisplayName } from "@app/util/formatters";
import roundToPrecision from "@app/util/number/roundToPrecision";

import { GroupByType } from "./enum/GroupByType";
import { GroupByEntity } from "./types/GroupByEntity";

interface Operations {
  calculate(record: RecordsStats): number;
  round(value: number): number;
}

export const displayTypeOperations: Record<DisplayType, Operations> = {
  [DisplayType.GROSS]: {
    calculate: ({ relevant }) => relevant,
    round: identity,
  },
  [DisplayType.PERCENT]: {
    calculate: ({ relevant, total }) => roundToPrecision(relevant / total, 4),
    round: (value) => roundToPrecision(value * 100, 2),
  },
};

export const entityName: Record<GroupByType, (entity: GroupByEntity) => string> = {
  [GroupByType.GROUP]: (group) => (group as Group).name,
  [GroupByType.TEAM]: (team) => (team as Team).name,
  [GroupByType.USER]: (user) => userDisplayName(user as User),
};
